import { Navigate, useParams } from 'react-router-dom';

import { useDuongDan } from '../../../hooks/useDuongDan';

/**
 * Hai đường cũ của native giữ để dấu trang và đường dẫn đã gửi đi không thành trang 404:
 * - `/tro-ly-ai/cong-cu-api` → `/tro-ly-ai/khuon` (Công cụ API đã thành khuôn API ở Truy vấn mẫu);
 * - `/tro-ly-ai/chatbot/:botId` → `/tro-ly-ai/tro-chuyen/:botId` (màn trò chuyện chuyển xuống dưới lưới bot, để quyền
 *   vào nó là quyền hỏi chứ không phải quyền sửa bot).
 */
export function ChuyenSangKhuon() {
  const duongDan = useDuongDan();
  return <Navigate to={duongDan('/tro-ly-ai/khuon')} replace />;
}

export function ChuyenSangTroChuyen() {
  const duongDan = useDuongDan();
  const { botId = '' } = useParams();
  return <Navigate to={duongDan(`/tro-ly-ai/tro-chuyen/${encodeURIComponent(botId)}`)} replace />;
}
